export const propertyDeedsSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedList']);
export const deedTypeListSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedTypeList', 'data']).toJS();
export const deedTypeListStateSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedTypeList']).toJS().state;
export const deedSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deed', 'data']).toJS();
export const deedStateSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deed']).toJS().state;
export const deedPropertyListSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedPropertyList', 'data']).toJS();
export const deedPropertyListStateSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedPropertyList']).toJS().state;
export const deedFileListSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'fileList', 'data']).toJS();
export const deedFileListStateSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'fileList']).toJS().state;
export const deedSellerListSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'sellerList', 'data']).toJS();
export const deedSellerListStateSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'sellerList']).toJS().state;
export const deedBuyerListSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'buyerList', 'data']).toJS();
export const deedBuyerListStateSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'buyerList']).toJS().state;

// deed lookup modal
export const deedLookupModalOpenSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedLookupModal', 'open']);
export const deedLookupModalModeSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedLookupModal', 'mode']);
export const deedLookupModalPropertyIdSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedLookupModal', 'propertyId']);
export const deedLookupModalStateSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedLookupModal', 'state']);
export const deedLookupModalDataSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedLookupModal', 'data']);
export const deedLookupModalSelectionSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deedLookupModal', 'selection']);
export const deedsSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'deeds']);
export const deedLetterCodesSelector = state =>
  state.getIn(['app', 'appraisal', 'deed', 'letterCodes']).toJS();
